import axios from 'axios';
// config
import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
  headers: {
    source: 'tenant',
  },
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/api/v1/admin/',
    login: '/api/v1/tenants/login',
    register: '/api/auth/register',
    details: '/api/v1/tenants/userDetails',
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  }, // mardam
  tenants: {
    list: '/api/v1/tenants/users',
    create: '/api/v1/tenants/signup',
    edit: (id) => `/api/v1/tenants/userDetails/${id}`,
  },
  scales: {
    list: '/api/v1/scales/get-all',
    add: '/api/v1/scales/create',
    edit: '/api/v1/scales/update',
    delete: '/api/v1/scales/delete',
  },
  hardware: {
    list: '/api/v1/hardware/get-all',
    add: '/api/v1/hardware/create',
    edit: '/api/v1/hardware/update',
    delete: '/api/v1/hardware/delete',
  },
  zones: {
    list: '/api/v1/zones/get-all',
    add: '/api/v1/zones/create',
    edit: '/api/v1/zones/update',
    delete: '/api/v1/zones/delete',
  },
  typeOfWaste: {
    list: '/api/v1/typeOfWaste/get-all',
    add: '/api/v1/typeOfWaste/create',
    edit: '/api/v1/typeOfWaste/update',
    delete: '/api/v1/typeOfWaste/delete',
  },
  landfillArea: {
    list: '/api/v1/landfillArea/get-all',
    add: '/api/v1/landfillArea/create',
    edit: '/api/v1/landfillArea/update',
    delete: '/api/v1/landfillArea/delete',
  },
  typesOfVehicles: {
    list: '/api/v1/vehicleType/get-all',
    add: '/api/v1/vehicleType/create',
    edit: '/api/v1/vehicleType/update',
    delete: '/api/v1/vehicleType/delete',
  },
  entryPermits: {
    list: '/api/v1/entryPermits/get-all',
    add: '/api/v1/entryPermits/create',
    edit: '/api/v1/entryPermits/update',
    delete: '/api/v1/entryPermits/delete',
  },
  cities: {
    list: '/api/v1/cities/all',
    // lookUp :(id)=>`/api/v1/cities/municipality/lookup/${id}`,
    create: '/api/v1/cities/create',
    edit: (id) => `/api/v1/cities/update/${id}`,
    delete: (id) => `/api/v1/cities/${id}`,
    // city ids
  },
  violations: {
    list: '/api/v1/voilations/getAll',
  },
  municipalities: {
    // city id
    list: (id) => `/api/v1/cities/municipality/lookup/${id}`,
    create: '/api/v1/cities/municipality/create',
    Bulkcreate: '/api/v1/cities/municipality/bulkAdd',
    // municipality id req
    edit: (id) => `/api/v1/cities/municipality/update/${id}`,
    // municipality id req
    delete: (id) => `/api/v1/cities/municipality/${id}`,
  },
  regions: {
    list: '/api/v1/regions',
    PickupPointslist: '/api/v1/pickuppoints/getUnAllocated',
    add: '/api/v1/regions',
    update: (id) => `/api/v1/regions/${id}`,
    assignSupervisor: '/api/v1/employee/assign-region',
    assignedPicks: (id) => `/api/v1/regions/${id}/pickup-points`,
  },
  pickupPoints: {
    list: '/api/v1/pickuppoints/getAll',
    unAssigned: '/api/v1/pickuppoints/getUnassignedPickupPoints',
    create: '/api/v1/pickuppoints/create',
    edit: (id) => `/api/v1/pickuppoints/update/${id}`,
    delete: '/api/v1/pickuppoints/delete',
    listByDriverId: '/api/v1/pickuppoints/getPickupPointsByDriverId',
  },
  garbageUnloading: {
    list: '/api/v1/garbageLogs/getAll?page=1&size=1000',
    add: '/api/v1/garbageLogs',
    edit: '/api/v1/garbageLogs',
    syncLogs: '/api/v1/garbageLogs/sync-logs',
    report: '/api/v1/garbageLogs/getReport',
  },
  dashboard: {
    getTotalPercentEntities: '/api/v1/dashboard/getTotalEntityCount',
    getTotalPercentActiveEntities: '/api/v1/dashboard/getActiveEntities',
    getWeightDetails: (value) => `/api/v1/dashboard/getWeightDetails?value=${value}`,
    getVehicleDetails: (value) => `/api/v1/dashboard/getVehicleDetails?value=${value}`,
    getVehicleWeightDetails: (value) => `/api/v1/dashboard/getVehicleWeightDetails?value=${value}`,
    getVehicleTypeDetails: (value) => `/api/v1/dashboard/getVehicleTypeDetails?value=${value}`,
  },
  contractors: {
    entity: {
      edit: (id) => `/api/v1/employee/${id}`,
      delete: (id) => `/api/v1/employee/${id}`,
      driverAssignPickup: '/api/v1/employee/assign-pickup-points',
    },
    driver: {
      list: '/api/v1/employee/drivers',
      create: '/api/v1/employee/signup',
      assign: (id) => `/api/v1/employee/link/${id}`,
    },
    supervisor: {
      list: '/api/v1/employee/supervisors',
      create: '/api/v1/employee/signup',
    },
    contractors: {
      assign: (id) => `/api/v1/contractors/link-vehicles-bulk/${id}`,
      dissociate: (id) => `/api/v1/contractors/unlink-vehicles-bulk/${id}`,
      edit: (id) => `/api/v1/contractors/update/${id}`,
      list: '/api/v1/contractors/all',
      create: '/api/v1/contractors/create',
      delete: (id) => `/api/v1/contractors/delete/${id}`,
    },
    vehicles: {
      list: '/api/v1/contractors/vehicles',
      list_contractor: (id) => `/api/v1/contractors/vehicles/${id}`,
      unlinked: '/api/v1/contractors/vehicles-not-assigned',
      create: '/api/v1/contractors/vehicles/create',
      edit: (id) => `/api/v1/contractors/vehicles/update/${id}`,
      delete: (id) => `/api/v1/contractors/vehicles/delete/${id}`,
      whiteList: `/api/v1/contractors/whitelist-vehicle`,
      removeWhiteList: `/api/v1/contractors/remove-whitelist-vehicle`,
    },
  },
  configurations: {
    profile: (id) => `/api/v1/tenants/${id}/details/tenant-user`,

    update: (id) => `/api/v1/tenants/${id}/tenant-user`,
    profileURL: '/api/v1/s3/tenantProfileURL',
    billing: {
      getSubReq: '/api/v1/tenants/getSubscriptionRequest',
      createSubReq: `/api/v1/tenants/createSubscriptionRequest`,
      currentSub: `/api/v1/tenants/getCurrentSubscription`,
    },
  },
  contracts: {
    list: '/api/v1/contracts/get-all',
    create: '/api/v1/contracts/create',
    edit: (id) => `/api/v1/contracts/update/${id}`,
    delete: (id) => `/api/v1/contracts/delete/${id}`,
  },
};
